const config = {
  serverUrl: process.env.REACT_APP_SERVER_URL || 'https://healthbuddy-uz19.onrender.com'
};

export default config; 